import request from '../../../axios';

const getStorePlans = async () => {
  const {data}: {data: GetStorePlansData} = await request.get(
    '/api/v2/subscription/store-plans',
  );
  return data;
};

export default getStorePlans;
